import React from "react";

export default function SchoolIcon() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1355 19.1558V10.6068C21.1355 9.90696 20.5785 9.34054 19.892 9.34054H16.9243L17.495 7.98666L11.9357 3.95725V2.7772C12.4962 2.81941 13.1636 2.91063 13.4167 3.10988C13.8827 3.47933 14.4008 4.11247 15.851 3.95407V1.21363C14.4008 1.37203 13.8827 0.738892 13.4167 0.369446C12.9502 5.41049e-08 11.0638 0 11.0638 0V3.95725L5.50451 7.98666L6.07568 9.34054H3.10801C2.42145 9.34054 1.86499 9.90741 1.86499 10.6068V19.1558H0V20H9.0135V12.9288H13.9865V20H23V19.1558H21.1355ZM5.50496 18.4696H3.21137V16.4117H5.50451V18.4696H5.50496ZM5.50496 15.6992H3.21137V13.6409H5.50451V15.6992H5.50496ZM5.50496 12.9288H3.21137V10.871H5.50451V12.9288H5.50496ZM11.5 10.1847C10.4414 10.1847 9.58333 9.31058 9.58333 8.2322C9.58333 7.15336 10.4414 6.27967 11.5 6.27967C12.5586 6.27967 13.4171 7.15336 13.4171 8.2322C13.4171 9.31058 12.5586 10.1847 11.5 10.1847ZM19.7886 18.4696H17.4955V16.4117H19.7886V18.4696ZM19.7886 15.6992H17.4955V13.6409H19.7886V15.6992ZM19.7886 12.9288H17.4955V10.871H19.7886V12.9288Z"
        fill="#33403E"
      />
    </svg>
  );
}
